import { StoryLevelData } from "@/app/lib/levels/story-level-data-types";
import { palindromes } from "@/app/lib/levels/palindromes";
import { pluralAnimals } from "@/app/lib/levels/plural-animals";
import { salad } from "@/app/lib/levels/salad";
import { colors } from "@/app/lib/levels/colors";
import { cars } from "@/app/lib/levels/cars";
import { british } from "@/app/lib/levels/british";
import { soup } from "@/app/lib/levels/soup";
import { baseball } from "@/app/lib/levels/baseball";

const LEVEL_DATAS: StoryLevelData[] = [
    pluralAnimals,
    palindromes,
    salad,
    colors,
    cars,
    british,
    soup,
    baseball
] as const;

export type LevelName = typeof LEVEL_DATAS[number]["levelName"];
const LEVEL_NAME_SET = new Set(
    LEVEL_DATAS.map(ld => ld.levelName)
);
export function isLevelName(x: unknown): x is LevelName {
    if (!(typeof x === 'string'))
        return false;

    return LEVEL_NAME_SET.has(x);
}

export type LevelID = typeof LEVEL_DATAS[number]["levelID"];
const LEVEL_ID_SET = new Set(
    LEVEL_DATAS.map(ld => ld.levelID)
);
export function isLevelID(x: unknown): x is LevelID {
    if (!(typeof x === 'string'))
        return false;

    return LEVEL_ID_SET.has(x);
}

export class FullStory {
    levelDatas: StoryLevelData[];
    finalLevel: number;

    constructor(levelDatas: StoryLevelData[]) {
        this.levelDatas = levelDatas;
        this.finalLevel = levelDatas.length;
        // iterate through the levels setting their number
        for (const [index, levelData] of levelDatas.entries()) {
            levelData.levelNumber = index + 1;
        }
    }

    getLevelByNumber(level: number) : StoryLevelData | null {
        if (level < 1 || level > this.finalLevel) {
            console.warn('tried to access a story level out of bounds');
            return null;
        }
        return this.levelDatas[level - 1];
    }
    getLevelByID(id: LevelID) : StoryLevelData | null {
        for (const levelData of this.levelDatas) {
            if (levelData.levelID === id) {
                return levelData;
            }
        }
        return null;
    }
    getLevelByName(levelName: LevelName) : StoryLevelData | null {
        for (const levelData of this.levelDatas) {
            if (levelData.levelName === levelName) {
                return levelData;
            }
        }
        return null;
    }
}

export const fullStory: FullStory = new FullStory(LEVEL_DATAS);